var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isGranted('EDIT_CLIENT'))?_c('q-btn',_vm._b({attrs:{"icon":"fa fa-pencil-alt","title":"Edit client"},on:{"click":_vm.editAccount}},'q-btn',_vm.$attrs,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }